import React from "react";

export const SocketContext = React.createContext();

export const withSocket = Comp => props => (
  <SocketContext.Consumer>
    {socket => {
      return <Comp socket={socket} {...props} />;
    }}
  </SocketContext.Consumer>
);
